import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import loading from "Resources/ImagesNew/Loading_3.gif";

const LoadingPage = (props) => {
  return (
    <>
      <div id="backgroundPopup2">
        <div style={{ textAlign: "center", padding: "15% 15% 0 0" }}>
          {/* <div style={{ textAlign: "center", padding: "15% 0" }}></div> */}
          <img class="mx-auto d-block" src={loading} width="50px" />

          <br />
          <b style={{ fontSize: "13px", color: " #CCCCCC" }}>
            Đang xử lý. Vui lòng chờ trong giây lát
          </b>
        </div>
      </div>
    </>
  );
};

LoadingPage.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default LoadingPage;
